/*
 * Copyright (c) Nexign, JSC, 2020.
 */
/**
 *
 *
 * @author Yakov Gushchin
 * @author Aleksandr Perkhunov
 * @version 1.10.0
 * @since 1.0.0
 */

import { EUserType } from '../../../../pages/PageAuth/constants/authConstants';
import { IAccess } from '../../types/guardTypes';
import { AccessComponentKeyEnum } from './guardConstants';

const FooterAccess: IAccess = {
    [AccessComponentKeyEnum.FooterAccount]: {},
    [AccessComponentKeyEnum.FooterHistoryOrder]: {},
    [AccessComponentKeyEnum.FooterHistoryInquiry]: {},
    [AccessComponentKeyEnum.FooterOffers]: {},
    [AccessComponentKeyEnum.FooterProducts]: {
        userTypeId: {
            isAllowed: false,
            id: [EUserType.SACS_ID_READONLY],
        },
    },
    [AccessComponentKeyEnum.FooterServicesSubscriberMobile]: {},
};

export default FooterAccess;
